import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right",
  "use": "icon-arrow--right-usage",
  "viewBox": "0 0 7 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 9\" id=\"icon-arrow--right\"><path d=\"M6.08 3.732a1 1 0 0 1 0 1.536L1.89 8.761a1 1 0 0 1-1.64-.768V1.007A1 1 0 0 1 1.89.239l4.19 3.493Z\" fill=\"#006442\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol